var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-screen"},[_c('div',{staticClass:"content-wrapper"},[_c('logo-skeleton',{staticClass:"logo",attrs:{"size":"150"}}),_c('p',[_vm._v("Loading Editor...")])],1),_c('ProgressView')],1)}
var staticRenderFns = []

export { render, staticRenderFns }